import React from 'react';
import App from './App';
import "bootstrap/dist/css/bootstrap.min.css"
import Auth from "./Auth"
import Form from './Form';
import Navbar from './navbar';
import ContactDetails from './ContactDetails';
import { BrowserRouter, Routes, Route } from "react-router-dom"
import  { useState } from 'react';
import Upload from './upload';
import Home from './home';
function Apps() {
  const [selectedContact, setSelectedContact] = useState("");
  const [admin , setAdmin] = useState(false);
  

  return (
    <div>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/admin" element={<Auth setAdmin={setAdmin} />} />
          <Route path="/" element={<App setSelectedContact={setSelectedContact} />} />
          <Route path="/form" element={<Form />} />
          <Route path="/update" element={<ContactDetails selectedContact={selectedContact} />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/home" element={<Home admin={admin} />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}

export default Apps;
